export const resolveAuthBaseURL = (apiUrl: string | undefined, origin: string): string =>
  new URL(apiUrl || "", origin).toString().replace(/\/$/, "");
